export default __webpack_public_path__ + "img/product-arrow-left.e75fc0e4.svg";